import { Avatar, Box, Grid } from "@mui/material";
// import ScrollDialog from "components/ScrollDialog";
import { memo, useCallback, useRef, useState } from "react";
// import ImageResize from "./ImageResize";
import { useSnackbar } from 'notistack';
import { saveLibraryPosterImage } from "services/libraries";
import FullScreenModal from "components/FullScreenModal";
import ImageCropper from "components/imageCropper";

export default memo(function PosterImage({libraryId}) {

  const [posterImage, setPosterImage] = useState(`/rest/libraries/images/${libraryId}/posterImage.jpg`)
  const [uploadImg, setUploadImg] = useState();
  // const [imageError, setImageError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const fileInputRef = useRef(null);
  
  const selectPosterImage = () => {
    fileInputRef.current.click();
  }

  const clearImageSelection = () => {
    setUploadImg(null);
    fileInputRef.current.value="";
  }

  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
      clearImageSelection();
    },
    [],
  );

  const closeModal = () => {
    setOpenModal(false);
    clearImageSelection();
  }

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
  }

  const uploadPosterPhoto = (imgSrc) => {
    saveLibraryPosterImage({ 
      image: dataURLtoFile(imgSrc, 'posterImage.jpg'), 
      libraryId
    }).then(({response, error}) => {
      if(response){
        setPosterImage(imgSrc);
        enqueueSnackbar("Image uploaded successfully", {variant: 'success'});
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
        clearImageSelection()
      }
    });
  }

  const uploadFile = useCallback((img) => {
    const imgSrc = img.src;
    uploadPosterPhoto(imgSrc);
    closeModal();
  }, []);

  const ShowModal = () => {
    // event.preventDefault();
    setOpenModal(true);
  }

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        //Initiate the JavaScript Image object.
        const image = new Image();

        //Set the Base64 string return from FileReader as source.
        image.src = reader.result;

        //Validate the File Height and Width.
        image.onload = (e) => {
          var height = image.height;
          var width = image.width;
          if (height < 1366 || width < 768) {
            enqueueSnackbar("Image should be atlest 1366px height and 768px width", {variant: 'error'});
            return false;
          }
          setUploadImg(reader.result);
          ShowModal();
          return true;
        };
        
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={12} md={12} lg={12} xl={10} textAlign="center" mt={4}>
        <Avatar 
          variant="rounded" 
          sx={{width: 150, height: 250, cursor: 'pointer', margin: '0 auto'}} 
          onClick={() => selectPosterImage()}
          src={posterImage}
          // onError={() => setImageError(true)}
          >
        </Avatar>
      </Grid>
      <input type="file" accept="image/*" ref={fileInputRef} onChange={onSelectFile} style={{display: 'none'}} />
      <FullScreenModal onModalClose={onModalClose} open={openModal} title="Image Upload">
        <ImageCropper upImg={uploadImg} uploadFile={uploadFile} cropAreaAspectRation={9/16} />
      </FullScreenModal>
    </Grid>
  )
})
